import { DailyLoginStreakTracker, StreakDay } from "interfaces";

export const getNextCollectionDay = (tracker: DailyLoginStreakTracker) => {
	const nextCollectionDay = tracker.streakDays.find((day: StreakDay) => {
		return tracker.nextCollectionDate === day.startOfDay;
	});

	return nextCollectionDay;
};
